<template>
  <div class="modal animated fadeIn" :class="{ 'is-active': $route.path.indexOf('/comments') > -1 }">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">{{ $t('proposal_comments_modal.comments') }}</p>
      </header>
      <section class="modal-card-body">

        <div class="no-comments" v-if="!comments || comments.length <= 0">
          <img src="/images/sad.png">
          <p>{{ $t('recent_comments.no_recent_comments') }}</p>
        </div>

        <ul v-if="comments !== false && comments.length > 0">
          <comment :comment="comment" :show-avatar="true" comment-type='full' v-for="comment in comments" :key="comment.id"></comment>
        </ul>
      </section>
      <footer class="modal-card-foot">
        <div contenteditable
          ref="commentBox"
          @focus="showCommentActionButtons = true"
          @blur="showCommentActionButtons = false"
          @keydown.enter.stop="submitComment"
          :disabled="disableNewComments"
          :placeholder="$t('proposal_comments_modal.comment_text_placeholder')"></div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
          <button class="button is-primary is-large is-pulled-left push-right" @click="submitComment" v-show="showCommentActionButtons">{{ $t('proposal_comments_modal.send_message') }}</button>
        </transition>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
          <button class="button is-primary is-large is-outlined is-pulled-left" @click="closeModal()" v-show="showCommentActionButtons">{{ $t('proposal_comments_modal.cancel') }}</button>
        </transition>
      </footer>
    </div>
  </div>
</template>

<script>
  import Tribute from 'tributejs';
  import TributeStyle from 'tributejs/dist/tribute.css';
  import API from 'mixins/api';
  import Comment from 'components/partials/comment.vue';

  export default {
    mixins: [API],
    components: {
      Comment,
    },
    data() {
      return {
        tribute: null,
        comments: false,
        disableNewComments: false,
        newCommentBody: '',
        showCommentActionButtons: false
      }
    },
    beforeMount() {
      this.api().fetchDocumentComments(this.$route.params.id)
        .then(comments => {
          this.comments = comments;
        });

      this.api().fetchTeamContacts()
        .then(contacts => {
          this.tribute = new Tribute({
            values: contacts,
            lookup: 'name',
            fillAttr: 'email',
            selectTemplate: function (item) {
              return item.original.email;
            },
          });

          this.tribute.attach(this.$refs.commentBox);
        });
    },
    mounted() {
      this.$refs.commentBox.onkeyup = () => {
        this.newCommentBody = this.$refs.commentBox.innerHTML;
      };
    },
    methods: {
      closeModal() {
        history.back();
      },
      resetCommentBox() {
        this.$refs.commentBox.innerHTML = '';
        this.newCommentBody = '';
      },
      submitComment() {
        if (this.tribute && this.tribute.isActive) { return; }

        this.disableNewComments = true;
        let comment = {
          body: this.newCommentBody,
        };

        if (window.Spark.state.user) {
          comment.type = "App\\User";
          comment.commenter_id = window.Spark.state.user.id;
        } else {
          comment.type = "App\\Contact";
          comment.commenter_id = window.viewer.id;
        }

        return this.api().createComment(this.$route.params.id, comment)
          .then(response => {
            // check for success
            this.resetCommentBox();
            this.disableNewComments = false;
            this.api().fetchDocumentComments(this.$route.params.id)
              .then(comments => {
                this.comments = comments;
              });
            (new Notyf()).confirm(this.$t('proposal_comments_modal.comment_sent'));
        },
        response => {
          this.disableNewComments = false;
          (new Notyf()).alert(this.$t('proposal_comments_modal.comment_sent_error'));
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";
  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }

  .button.is-primary.is-large {
    padding: 21px 25px 19px;
  }

  .no-comments {
    margin-top: 100px;
    img {
      width: 40px;
      display: block;
      margin: 0 auto 20px;
    }
    p {
      font-size: 12px;
      text-transform: uppercase;
      font-weight: 600;
      margin: 0 auto;
      text-align: center;
      letter-spacing: 1px;
    }
  }

  .modal {
    .modal-card {
      height: calc(100vh - 100px);
      margin-top: 50px;
      &-head {
        border-bottom: 1px solid lighten($mutedblue, 12%);
        padding: 24px 40px 22px;
      }
      &-body {
        padding-top: 25px;
        ul {
          list-style-type: none;
          margin: 0;
          padding: 0;
        }
      }
      &-foot {
        border-top: 1px solid lighten($mutedblue, 12%);
        padding: 24px 40px;
        .button {
          margin-top: 0;
          opacity: 1;
          pointer-events: auto;
          -webkit-transition: all 0.3s .1s;
          -moz-transition: all 0.3s .1s;
          transition: all 0.3s .1s;
        }
        div[contenteditable] {
          border: 1px solid #d8e1ea;
          width: 100%;
          padding: 10px;
          margin-top: 5px;
          font-size: 14px;
          resize: none;
          border-radius: 2px;
          text-align: left;
          height: 43px;
          -webkit-transition: all 0.3s .1s;
          -moz-transition: all 0.3s .1s;
          transition: all 0.3s .1s;
          &:empty:before {
            content: attr(placeholder);
          }
          &:focus {
            margin-bottom: 15px;
            height: 100px;
            -webkit-transition: all 0.3s;
            -moz-transition: all 0.3s;
            transition: all 0.3s;

          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// document-comments-modal.vue?e1afd3ea